export default "__VITE_ASSET__DsX6v1SQ__"